/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PoolListDto interface.
 */
export function instanceOfPoolListDto(value) {
    if (!('pools' in value) || value['pools'] === undefined)
        return false;
    return true;
}
export function PoolListDtoFromJSON(json) {
    return PoolListDtoFromJSONTyped(json, false);
}
export function PoolListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pools': json['pools'],
    };
}
export function PoolListDtoToJSON(json) {
    return PoolListDtoToJSONTyped(json, false);
}
export function PoolListDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pools': value['pools'],
    };
}
